var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBackground"},[_c('dl',[_c('dt',[_c('img',{attrs:{"src":_vm.baseUrl+'img/404.png'}})]),_c('dd',[_vm._v("\n      网络出问题了，我要\n      "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.refeshPage}},[_vm._v("立即刷新")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }